/** Light red for failures and stop-control hover (icon only). */
export const TASK_LIGHT_RED = "text-rose-400";
export const TASK_LIGHT_RED_HOVER = "hover:text-rose-400";

/** Muted progress label (e.g. "3 done"). */
export const TASK_COUNTER_LIGHT = "text-slate-400 dark:text-slate-300";
/** Emphasis on total (e.g. "/ 42" or "40 / 42"). */
export const TASK_COUNTER_DARK = "text-slate-600 dark:text-slate-500";

/** Cancelled / incomplete accent — matches StatusDot `yellow`. */
export const TASK_CANCELLED_YELLOW = "text-yellow-400 dark:text-yellow-300";
export const TASK_CANCELLED_PROGRESS_FILL = "bg-yellow-400";
